import { createContext, useContext } from 'react';

export type ToastTone = 'success' | 'info' | 'error';

export interface Toast {
  id: number;
  tone: ToastTone;
  title: string;
  body?: string;
  /** One button in the toast, e.g. "Undo"; the toast closes when it is used. */
  action?: { label: string; onClick: () => void };
  /**
   * RL-1658 review: called while the toast is hovered or focused (its own
   * timer is held too) and when that ends, e.g. to hold an Undo window.
   */
  onPause?: () => void;
  onResume?: () => void;
  error?: unknown;
  onRetry?: () => void;
}

export interface ToastApi {
  show: (toast: Omit<Toast, 'id'>, durationMs?: number) => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

export function useToast(): ToastApi {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside <ToastProvider>');
  return ctx;
}
